import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    event.preventDefault()
    clearTimeout(this._closeTimer)

    if (this.isOpen()) {
      this.hide()
      return
    }

    this.show()
  }

  open() {
    clearTimeout(this._closeTimer)
    this.show()
  }

  close() {
    this._closeTimer = setTimeout(() => {
      this.hide()
    }, 150)
  }

  disconnect() {
    clearTimeout(this._closeTimer)
  }

  isOpen() {
    return this.panelTarget.style.display === "block"
  }

  show() {
    this.panelTarget.style.display = "block"
  }

  hide() {
    this.panelTarget.style.display = "none"
  }
}
